
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-location-config",
})
export default class LocationConfig extends ComponentConfigMixins {}
